import { render, staticRenderFns } from "./AiChatSideBar.vue?vue&type=template&id=7bdfdea8&scoped=true&"
import script from "./AiChatSideBar.vue?vue&type=script&lang=js&"
export * from "./AiChatSideBar.vue?vue&type=script&lang=js&"
import style0 from "./AiChatSideBar.vue?vue&type=style&index=0&id=7bdfdea8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdfdea8",
  null
  
)

export default component.exports